import lazyLoading from './modules/menu/lazyLoading'

export default [
  {
    name: 'Stories',
    meta: {
      title: 'Stories'
    },
    path: '/stories',
    component: lazyLoading('stories/Stories')
  },
  {
    name: 'Account',
    path: '/account',
    component: lazyLoading('account/Account'),
    meta: {
      title: 'Account'
    }
  },
  {
    name: 'Profile',
    path: '/profile',
    component: lazyLoading('profile/Profile'),
    meta: {
      title: 'Profile'
    }
  },
  {
    name: 'Billing',
    path: '/billing',
    component: lazyLoading('billing/Billing'),
    meta: {
      title: 'Billing'
    }
  },
  {
    name: 'CDR',
    path: '/cdr',
    component: lazyLoading('cdr/CDRs'),
    meta: {
      title: 'CDR'
    }
  },
  {
    name: 'Contacts',
    path: '/contacts',
    component: lazyLoading('contacts/Contacts'),
    meta: {
      title: 'Contacts'
    },
    children: [
      {
        name: 'Contact',
        path: '/contacts/:id',
        component: lazyLoading('contacts/Contact'),
        meta: {
          title: 'Contact'
        }
      }
    ]
  },
  {
    name: 'Devices',
    path: '/devices',
    component: lazyLoading('devices/Devices'),
    meta: {
      title: 'Devices'
    },
    children: [
      {
        name: 'Device',
        path: '/devices/:id',
        component: lazyLoading('devices/Device'),
        meta: {
          title: 'Device'
        }
      }
    ]
  },
  {
    name: 'Documents',
    path: '/documents',
    component: lazyLoading('documents/Documents'),
    meta: {
      title: 'Documents'
    },
    children: [
      {
        name: 'Document',
        path: '/documents/:id',
        component: lazyLoading('documents/Document'),
        meta: {
          title: 'Document'
        }
      }
    ]
  },
  {
    name: 'Integrations',
    path: '/integrations',
    component: lazyLoading('integrations/Integrations'),
    meta: {
      title: 'Integrations'
    },
    children: [
      {
        name: 'Integration',
        path: '/integrations/:id',
        component: lazyLoading('integrations/Integration'),
        meta: {
          title: 'Integration'
        }
      }
    ]
  },
  {
    name: 'Fonenumbers',
    path: '/fonenumbers',
    component: lazyLoading('fonenumbers/Fonenumbers'),
    meta: {
      title: 'Fonenumbers'
    },
    children: [
      {
        name: 'Fonenumber',
        path: '/fonenumbers/:id',
        component: lazyLoading('fonenumbers/Fonenumber'),
        meta: {
          title: 'Fonenumber'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/store/structure.js